// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_fo-0";